import React from 'react';
import { Table, Card, Tag, Button, Space, Avatar, Badge, Row, Col, Statistic, message } from 'antd';
import { PlusOutlined, TeamOutlined, UserOutlined, ShopOutlined } from '@ant-design/icons';

const users = [
  { key: '1', name: '深圳割草机科技', type: 'agent', cards: 1200, balance: 28600, status: 'active', contact: '张经理', phone: '13812345678', level: '一级代理' },
  { key: '2', name: '广州CPE设备公司', type: 'client', cards: 860, balance: 15200, status: 'active', contact: '李总', phone: '13987654321', level: '终端客户' },
  { key: '3', name: '北京VR体验馆', type: 'client', cards: 300, balance: 8900, status: 'active', contact: '王总监', phone: '13611223344', level: '终端客户' },
  { key: '4', name: '上海安防系统集成商', type: 'agent', cards: 540, balance: 22400, status: 'active', contact: '赵主管', phone: '13700112233', level: '二级代理' },
  { key: '5', name: '成都对讲机厂商', type: 'client', cards: 420, balance: 6800, status: 'inactive', contact: '陈工', phone: '13900556677', level: '终端客户' },
  { key: '6', name: '武汉IoT平台公司', type: 'agent', cards: 1800, balance: 45600, status: 'active', contact: '刘总', phone: '13500778899', level: '一级代理' },
];

const typeMap: Record<string, any> = {
  agent: { color: 'purple', text: '代理商', icon: <ShopOutlined /> },
  client: { color: 'blue', text: '终端客户', icon: <UserOutlined /> },
};

const UserManage: React.FC = () => (
  <div style={{ padding: 16 }}>
    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
      {[
        { title: '总客户数', value: 286, icon: <TeamOutlined />, color: '#1890ff' },
        { title: '代理商', value: 42, icon: <ShopOutlined />, color: '#722ed1' },
        { title: '终端客户', value: 244, icon: <UserOutlined />, color: '#52c41a' },
        { title: '总余额(¥)', value: '128,600', color: '#fa8c16' },
      ].map((item, i) => (
        <Col span={6} key={i}>
          <Card bordered={false} style={{ borderRadius: 8 }}>
            <Statistic title={item.title} value={item.value} valueStyle={{ color: item.color, fontWeight: 700 }} />
          </Card>
        </Col>
      ))}
    </Row>

    <Card
      title={<span><TeamOutlined /> 客户/渠道管理</span>}
      extra={<Button type="primary" icon={<PlusOutlined />}>新建客户</Button>}
      bordered={false}
      style={{ borderRadius: 8 }}
    >
      <Table
        dataSource={users}
        size="small"
        pagination={{ pageSize: 10, showTotal: t => `共 ${t} 条` }}
        columns={[
          {
            title: '客户名称', dataIndex: 'name', key: 'name',
            render: (v, r: any) => (
              <Space>
                <Avatar style={{ backgroundColor: r.type === 'agent' ? '#722ed1' : '#1890ff', fontSize: 12 }}>
                  {v[0]}
                </Avatar>
                <span style={{ fontWeight: 500 }}>{v}</span>
              </Space>
            )
          },
          {
            title: '类型', dataIndex: 'type', key: 'type',
            render: (v: string) => <Tag color={typeMap[v]?.color} icon={typeMap[v]?.icon}>{typeMap[v]?.text}</Tag>
          },
          { title: '层级', dataIndex: 'level', key: 'level' },
          { title: '持卡数', dataIndex: 'cards', key: 'cards', render: v => v.toLocaleString() },
          { title: '余额(¥)', dataIndex: 'balance', key: 'balance', render: v => <span style={{ color: '#52c41a', fontWeight: 600 }}>¥{v.toLocaleString()}</span> },
          { title: '联系人', dataIndex: 'contact', key: 'contact' },
          { title: '手机号', dataIndex: 'phone', key: 'phone' },
          {
            title: '状态', dataIndex: 'status', key: 'status',
            render: v => <Badge status={v === 'active' ? 'success' : 'default'} text={v === 'active' ? '正常' : '停用'} />
          },
          {
            title: '操作', key: 'action',
            render: () => (
              <Space>
                <Button size="small">查看</Button>
                <Button size="small">充值</Button>
                <Button size="small">子账号</Button>
              </Space>
            )
          },
        ]}
      />
    </Card>
  </div>
);

export default UserManage;
